import { Error, InfoIcon } from '../Icons'
import CheckCircle from '../Icons/checkCircle'
import { StatusContainer } from './styles'

export type TypeProps = 'pending' | 'approved' | 'refused' | 'info' | 'expired'

type StatusProps = {
  type: TypeProps
  typeMessage: string
}

const statusIcon = (type: TypeProps) => {
  switch (type) {
    case 'pending':
      return (
        <InfoIcon
          color="white"
          size={20}
          style={{ transform: 'scale(0.85)' }}
        />
      )
    case 'approved':
      return <CheckCircle color="white" size={20} />
    case 'refused':
    case 'expired':
      return <Error color="white" size={20} />

    case 'info':
      return (
        <InfoIcon
          color="white"
          size={20}
          style={{ transform: 'scale(0.85)' }}
        />
      )
    default:
      return null
  }
}

export const Status = ({ type, typeMessage }: StatusProps) => {
  return (
    <StatusContainer type={type}>
      {statusIcon(type)}
      <span>{typeMessage}</span>
    </StatusContainer>
  )
}
